import { Col, Pagination, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import './style.css'
import Tabs from '../../../../components/Tabs';
import BookingCard from './BookingCard';
import useBookingApi from '../../../../config/hooks/api/booking/useBookingApi';
import { useDispatch } from 'react-redux';
import { setAppLoading } from '../../../../store/common/generalSlice';
import { bookingStatusTabs } from '../../../../config/utils/constants';
import { useParams } from 'react-router-dom';
import { getBookingStatus } from '../../../../config/utils';

const MyBookingsList = () => {

    const { bookingStatusId } = useParams()
    const [selectedBookingType, setSelectedBookingType] = useState(
        (bookingStatusId && getBookingStatus(bookingStatusId)) || null
    )
    const [menuItems, setMenuItems] = useState(bookingStatusTabs)

    useEffect(() => {
        const hasContent = menuItems.some(e => e.content)
        if(!hasContent){
            const updatedTabArray = menuItems.map(item => ({    
                ...item,
                content: <TabContent key={item.id} bookingStatus={item.status} />
            }));
            setMenuItems(updatedTabArray)
        }
    }, [menuItems])
    

    return (
        <Tabs
            defaultActiveKey="1"
            selectedTab={selectedBookingType}
            data={menuItems}
            className='tabs'
        />
    )
}

export default MyBookingsList



const TabContent = (props) => {
    const dispatch = useDispatch()
    const { getUserBookings } = useBookingApi()

    const [selectedBookings, setSelectedBookings] = useState([])
    const [offset, setOffset] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0)


    const getMyBookingsList = async (bkStatus) => {
        try {
            dispatch(setAppLoading(true))
            const response = await getUserBookings(pageSize, offset, bkStatus > -1 ? bkStatus : '') //default limit, offset,
            if (response) {
                const filtered = response?.data?.bookings?.rows.filter(e=>e.serviceProvider?.userDetail?.businessName)
                setSelectedBookings(filtered)

                setTotalItems(response?.data?.bookings?.count)
                setOffset(offset + pageSize)

                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const onShowSizeChange = (current, pageSize) => {
        setPageSize(pageSize)
    };

    const onPageChange = (page) => {
        setCurrentPage(page);
        setOffset((page - 1) * pageSize)
    };


    useEffect(() => {
        getMyBookingsList(props?.bookingStatus)
    }, [props?.bookingStatus, currentPage, pageSize])


    return (
        <Row className='md:mb-4 sm:mb-4 mb-6 w-full'>
            {
            selectedBookings && selectedBookings.length ? 
            selectedBookings.map((booking, index) => (
                <Col xl={8} md={12} xs={24} className='cursor-pointer' key={'sb'+index}>
                    <BookingCard bookingData={booking} key={index} />
                </Col>
            )) : ''}
            <Col span={24}>
                <div className='px-2 py-4 bg-white rounded-md'>
                    <Pagination
                        defaultPageSize={5}
                        showSizeChanger
                        onShowSizeChange={onShowSizeChange}
                        current={currentPage}
                        total={totalItems}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 20, 50]}
                        onChange={onPageChange}
                    />
                </div>
            </Col>
        </Row>
    )
}


